import React from 'react';
import type { V2Route } from '../units/types';

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [{ path: 'ads/lp', Component: React.lazy(() => import('./LpPage')), guard: { kind: 'feature', feature: 'enable_lp_creation' } }];

export default routes;
